export function ClassicPreview(): JSX.Element {
  return (
    <div className="appearance-preview preview-classic">
      <i />
      <div>
        <b />
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
